import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    flowType: "TRACK_CLAIM_LOGGED_OUT",
    currentStepIndex: 0,
    currentSubstepIndex: 0,
    trackClaimFormData: {
        cprNumber: "",
        claimNumber: ""
    }
};

const trackClaimFlowSlice = createSlice({
    name: "trackClaimFlow",
    initialState,
    reducers: {
        setTrackClaimFlowType: (state, action) => {
            const { type, currentStepIndex, currentSubstepIndex } = action.payload;
            state.flowType = type;
            state.currentStepIndex = currentStepIndex ?? 0;
            state.currentSubstepIndex = currentSubstepIndex ?? 0;
        },
        setCurrentStepIndex: (state, action) => {
            state.currentStepIndex = action.payload;
            state.currentSubstepIndex = 0;
        },
        setCurrentSubstepIndex: (state, action) => {
            state.currentSubstepIndex = action.payload;
        },
        setTrackClaimFormData: (state, action) => {
            state.trackClaimFormData = {
                ...state.trackClaimFormData,
                ...action.payload
            };
        },
        clearTrackClaimFormData: (state) => {
            state.trackClaimFormData = initialState.trackClaimFormData;
        },
        resetTrackClaimFlow: (state) => {
            return initialState;
        }
    }
});

export const {
    setTrackClaimFlowType,
    setCurrentStepIndex,
    setCurrentSubstepIndex,
    setTrackClaimFormData,
    clearTrackClaimFormData,
    resetTrackClaimFlow
} = trackClaimFlowSlice.actions;

export const selectTrackClaimFlowType = (state) => state.trackClaimFlow?.flowType;
export const selectCurrentStepIndex = (state) => state.trackClaimFlow?.currentStepIndex ?? 0;
export const selectCurrentSubstepIndex = (state) => state.trackClaimFlow?.currentSubstepIndex ?? 0;
export const selectTrackClaimFormData = (state) => state.trackClaimFlow?.trackClaimFormData;

export default trackClaimFlowSlice.reducer;
